import React from 'react'
// libs
import styled from 'styled-components'
// utils
import moment from 'moment'
// themes
import { colors } from 'themes'

// styled
const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 16px 0;
  width: inherit;
`

const MetadataWrapper = styled.div`
  align-items: center;
  display: flex;
  font-weight: 500;
  justify-content: center;
  margin: 0 5px;
  width: 100%;

  :before {
    background-color: ${colors.black};
    content: '';
    height: 1px;
    width: 100%;
  }

  :after {
    background-color: ${colors.black};
    content: '';
    height: 1px;
    width: 100%;
  }

  span {
    margin: 0 4px;
    white-space: nowrap;
  }
`

interface IIncomingProps {
  date: string
}

const DateTitle: React.FunctionComponent<IIncomingProps> = ({ date }) => {
  const formatActivityDate = date => moment(date).format(' dddd, MMMM D')

  return (
    <Wrapper>
      <MetadataWrapper>
        <span>{formatActivityDate(date)}</span>
      </MetadataWrapper>
    </Wrapper>
  )
}

export default DateTitle
